/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ShivaWebPublicConfiguration, ShivaWebPublicConfigurationParams } from './shiva-web-public-configuration';

import { PersonalSpaceService } from './services/personal-space.service';
import { MapService } from './services/map.service';
import { StationService } from './services/station.service';
import { OccupancyService } from './services/occupancy.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    PersonalSpaceService,
    MapService,
    StationService,
    OccupancyService,
    ShivaWebPublicConfiguration
  ],
})
export class ShivaWebPublicModule {
  static forRoot(params: ShivaWebPublicConfigurationParams): ModuleWithProviders<ShivaWebPublicModule> {
    return {
      ngModule: ShivaWebPublicModule,
      providers: [
        {
          provide: ShivaWebPublicConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: ShivaWebPublicModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('ShivaWebPublicModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
